import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemsRecommendationsComponent } from './systems-recommendations.component';
import { HelpCardSlideModule } from '@app/wiki/help/components/help-card-slide/help-card-slide.module';

@NgModule({
    declarations: [SystemsRecommendationsComponent],
    exports: [SystemsRecommendationsComponent],
    imports: [CommonModule, HelpCardSlideModule]
})
export class SystemsRecommendationsModule {}
